declare namespace $ {

	type $bog_theme_auto__theme_light_bog_bzrl_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_bzrl_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_bzrl_app_Theme__4 = $mol_type_enforce<
		`$mol_theme_homerent_light`
		,
		string
	>
	type $bog_bzrl_app_Theme__5 = $mol_type_enforce<
		`$mol_theme_homerent_dark`
		,
		string
	>
	type $bog_theme_auto__themes_default_bog_bzrl_app_3 = $mol_type_enforce<
		readonly(string)[]
		,
		ReturnType< $bog_theme_auto['themes_default'] >
	>
	type $mol_image__uri_bog_bzrl_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_bog_bzrl_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_bzrl_app_profile__theme_auto_bog_bzrl_app_9 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['Theme'] >
		,
		ReturnType< $bog_bzrl_app_profile['theme_auto'] >
	>
	type $mol_view__sub_bog_bzrl_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_bzrl_app_rent__attr_bog_bzrl_app_11 = $mol_type_enforce<
		({ 
			'id': string,
		}) 
		,
		ReturnType< $bog_bzrl_app_rent['attr'] >
	>
	type $bog_bzrl_app_rent__district_bog_bzrl_app_12 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['filter_district'] >
		,
		ReturnType< $bog_bzrl_app_rent['district'] >
	>
	type $bog_bzrl_app_rent__rooms_bog_bzrl_app_13 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['filter_rooms'] >
		,
		ReturnType< $bog_bzrl_app_rent['rooms'] >
	>
	type $bog_bzrl_app_rent__price_from_bog_bzrl_app_14 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['filter_price'] >
		,
		ReturnType< $bog_bzrl_app_rent['price_from'] >
	>
	type $bog_bzrl_app_rent__search_bog_bzrl_app_15 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['apartments_search'] >
		,
		ReturnType< $bog_bzrl_app_rent['search'] >
	>
	type $bog_bzrl_app_rent__apartments_bog_bzrl_app_16 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['apartments_filtered'] >
		,
		ReturnType< $bog_bzrl_app_rent['apartments'] >
	>
	type $bog_bzrl_app_rent__promo_action_bog_bzrl_app_17 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['promo_action'] >
		,
		ReturnType< $bog_bzrl_app_rent['promo_action'] >
	>
	type $bog_bzrl_app_let__action_bog_bzrl_app_18 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app['let_action'] >
		,
		ReturnType< $bog_bzrl_app_let['action'] >
	>
	export class $bog_bzrl_app extends $mol_page {
		Theme( ): $bog_theme_auto
		Logo_icon( ): $mol_image
		logo_home( ): string
		l( ): string
		logo_rent( ): string
		Logo_text( ): $mol_view
		Logo( ): $mol_view
		Nav( ): $bog_bzrl_app_nav
		Profile( ): $bog_bzrl_app_profile
		Actions( ): $mol_view
		filter_district( next?: string ): string
		filter_rooms( next?: string ): string
		filter_price( next?: string ): string
		apartments_search( next?: any ): any
		apartments_filtered( ): readonly(any)[]
		promo_action( next?: any ): any
		Rent_page( next?: $bog_bzrl_app_rent ): $bog_bzrl_app_rent
		let_action( next?: any ): any
		Let_page( next?: $bog_bzrl_app_let ): $bog_bzrl_app_let
		title( ): string
		plugins( ): readonly(any)[]
		head( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map